// 不同国家，不同业务类型对应的服务code
export const serviceCodeData = {
  Singapore: {
    // 公司设立
    COMPANY_INCORPORATION: {
      // 必选服务code列表; [SG-CR1]公司设立(ACRA 注册)服务
      requiredServiceCodeList: ["SG-CR1"],
      // 公司注册地址服务code列表
      companyRegistrationAddressServiceCodeList: ["SG-O01", "SG-A01"],
      // 名义董事服务code列表
      nomineeDirectorServiceCodeList: ["SG-N1"],
      // 就业准证(EP)申请服务code列表
      epApplicationServiceCodeList: ["SG-EP01"],
      // 公司秘书服务-基本服务code列表
      companySecretaryServiceCodeList: ["SG-S01"],
    },
    // 公司服务的转移 – 公司秘书相关的服务
    SERVICE_TRANSFER: {
      // 必选服务code列表; [SG-S01]公司秘书服务-基本
      requiredServiceCodeList: ["SG-S01"],
      // 公司注册地址服务code列表
      companyRegistrationAddressServiceCodeList: ["SG-O01", "SG-A01"],
      // 名义董事服务code列表
      nomineeDirectorServiceCodeList: ["SG-N1"],
      // 就业准证(EP)申请服务code列表
      epApplicationServiceCodeList: ["SG-EP01"],
      // 公司秘书服务-基本服务code列表
      companySecretaryServiceCodeList: ["SG-S01"],
    },
  },
  Malaysia: {
    // 公司设立
    COMPANY_INCORPORATION: {
      // 必选服务code列表; [Sec-MY-005]公司设立服务
      requiredServiceCodeList: ["Sec-MY-005"],
      // 公司注册地址服务code列表
      companyRegistrationAddressServiceCodeList: ["Sec-MY-002"],
      // 名义董事服务code列表
      nomineeDirectorServiceCodeList: ["Sec-MY-003", "Sec-MY-003a"],
      // 公司秘书服务-基本服务code列表
      companySecretaryServiceCodeList: ["Sec-MY-001"],
    },
    // 公司服务的转移 – 公司秘书相关的服务
    SERVICE_TRANSFER: {
      // 必选服务code列表; [Sec-MY-001]公司秘书服务-基本
      requiredServiceCodeList: ["Sec-MY-001"],
      // 公司注册地址服务code列表
      companyRegistrationAddressServiceCodeList: ["Sec-MY-002"],
      // 名义董事服务code列表
      nomineeDirectorServiceCodeList: ["Sec-MY-003", "Sec-MY-003a"],
      // 公司秘书服务-基本服务code列表
      companySecretaryServiceCodeList: ["Sec-MY-001"],
    },
  },
};
